module.exports = __webpack_public_path__ + "static/media/FPI-and-me-es-program.45ac77df.png";